<template>
  <div>
    <div v-for="(group, groupIndex) in checklistGroups" :key="groupIndex" class="checklist-group-block">
      <div class="checklist-group-header">{{ group.headerLabel }}</div>
      <v-client-table
        :key="'checklistGrid-' + groupIndex"
        class="hiaTable"
        :ref="'checklistGrid' + groupIndex"
        :id="'checklistGrid' + groupIndex"
        :data="group.rows"
        :columns="columns"
        :options="options"
        uniqueKey="_rowKey"
      >
        <template slot="answer" slot-scope="props">
          <div v-if="props.row.answer">
            <label class="answer-label">
              <input type="radio" v-model="props.row.answer" :value="1" disabled class="custom-radio" /> Yes
            </label>
            <label class="answer-label">
              <input type="radio" v-model="props.row.answer" :value="2" disabled class="custom-radio" /> No
            </label>
            <label class="answer-label">
              <input type="radio" v-model="props.row.answer" :value="3" disabled class="custom-radio" /> NA
            </label>
          </div>
        </template>
      </v-client-table>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'coderChecklists',
    props: {
      checklists: {
        type: Array,
        default: function() {
          return []
        }
      },
      showCodeType: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      checklistGroups() {
        const arr = this.checklists || []
        const groupMap = new Map()

        for (const row of arr) {
          const key = this.showCodeType ? `${row.codeDesc || ''}|${row.checklistName}` : row.checklistName
          if (!groupMap.has(key)) {
            groupMap.set(key, {
              checklistName: row.checklistName,
              codeDesc: row.codeDesc,
              rows: []
            })
          }
          groupMap.get(key).rows.push(row)
        }

        return [...groupMap.values()]
          .sort((a, b) => {
            if (this.showCodeType) {
              const codeCompare = (a.codeDesc || '').localeCompare(b.codeDesc || '')
              if (codeCompare !== 0) return codeCompare
            }
            return (a.checklistName || '').localeCompare(b.checklistName || '')
          })
          .map((group, groupIndex) => ({
            ...group,
            headerLabel: this.headerLabelForGroup(group),
            rows: this.mapGridRows(group.rows, groupIndex)
          }))
      },
      columns() {
        return ['itemName', 'answer']
      },
      options() {
        return {
          filterable: false,
          filterByColumn: false,
          resizableColumns: false,
          queue: [],
          networkFunction: null,
          perPage: 100,
          columnsClasses: {
            itemName: 'itemNameCol',
            answer: 'answerCol'
          },
          headings: {
            itemName: 'Item',
            answer: 'Answer'
          }
        }
      }
    },
    methods: {
      headerLabelForGroup(group) {
        if (group.codeDesc) {
          return `${group.codeDesc} - ${group.checklistName}`
        }
        return group.checklistName
      },
      mapGridRows(rows, groupIndex) {
        return [...rows].map((row, index) => ({
          ...row,
          _rowKey: `${groupIndex}-${index}-${row.itemName}`,
          answer: row.answer != null && row.answer !== '' ? Number(row.answer) : null
        }))
      }
    }
  }
</script>

<style scoped>
  .checklist-group-block {
    margin-bottom: 16px;
  }

  .checklist-group-block:last-child {
    margin-bottom: 0;
  }

  .checklist-group-header {
    background-color: #fafafa;
    text-align: center;
    padding: 5px;
    font-size: 13px;
    font-weight: 600;
    color: #606266;
  }

  .answer-label {
    margin-right: 25px;
  }

  .custom-radio {
    appearance: none;
    -webkit-appearance: none;
    background-color: white;
    border: 1px solid lightgrey;
    border-radius: 50%;
    width: 12px;
    height: 12px;
    position: relative;
    background-color: white !important;
  }

  .custom-radio:disabled {
    background-color: white;
  }

  .custom-radio:checked::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 12px;
    height: 12px;
    background-color: rgb(182, 194, 207);
    border-radius: 50%;
    transform: translate(-50%, -50%);
  }

  >>> .itemNameCol {
    width: 50%;
    min-width: 50%;
  }

  >>> .answerCol {
    width: 50%;
    min-width: 50%;
  }

  >>> td {
    font-size: 13px !important;
  }
</style>
